import { render, staticRenderFns } from "./tableMoves.vue?vue&type=template&id=73d2c306&"
import script from "./tableMoves.js?vue&type=script&lang=js&"
export * from "./tableMoves.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports